module.exports = __webpack_public_path__ + "media/images/cv/Certificate-b10f756eb98a07642f0db3fe36939c3a.jpg";